if (!customElements.get('readers-featured-products-plp')) {
    class ReadersFeaturedProductsPlp extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.style.display = 'block';
        }
    }

    customElements.define('readers-featured-products-plp', ReadersFeaturedProductsPlp);
}